import { render, staticRenderFns } from "./OdinSoftware.vue?vue&type=template&id=7a818710"
import script from "./OdinSoftware.vue?vue&type=script&lang=js"
export * from "./OdinSoftware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports